import { React } from 'react'

import './Skeleton.css'
import './MSkeleton.css'

function SkeletonLine(props) {
    return (
        <div
            className='skeleton skeleton-line'
            style={{ width: props.width || '100%', height: (props.height || 14) + 'px' }}
            aria-hidden="true"
        />
    )
}

function SkeletonCard() {
    return (
        <div className='skeleton-card' aria-hidden="true">
            <div className='skeleton skeleton-line' style={{ width: '55%', height: '18px' }} />
            <div className='skeleton skeleton-line' style={{ width: '38%', height: '12px' }} />
            <div className='skeleton skeleton-line' style={{ width: '72%', height: '12px' }} />
            <div className='skeleton skeleton-btn' />
        </div>
    )
}

export default function Skeleton(props) {
    const variant = props.variant || 'line'

    if (variant === 'card') {
        return <SkeletonCard />
    }

    if (variant === 'grid') {
        const cols = props.cols || 3
        const count = props.count || cols
        return (
            <div className={'skeleton-grid skeleton-grid-' + cols} aria-hidden="true">
                {Array.from({ length: count }).map((_, i) => (
                    <SkeletonCard key={i} />
                ))}
            </div>
        )
    }

    return <SkeletonLine width={props.width} height={props.height} />
}
